// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3g3b9","description":"PatientConsentPreview_description__2MVnP"};